import Fetch from "./index";

export const getNativeClientPlatform = async (id) => {
    if (!id)
        return Promise.reject("failed to read id");

    return Fetch("/native-client-platform/" + id)
}

export const getNativeClientPlatforms = async (filters) => {
    const filter = new URLSearchParams(filters).toString();
    return Fetch(`/native-client-platform?${filter}`)
}

export const getNativeClientPlatformStats = async () => {
    return Fetch('/native-client-platform/stats')
}

export const updateNativeClientPlatform = async (id, data) => {
    return Fetch(
        '/native-client-platform/' + id,
        {
            method: 'PUT',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
            }
        },
    )
}

export const deleteNativeClientPlatform = async (id) => {
    return Fetch(
        '/native-client-platform/' + id,
        {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json",
            }
        },
    )
}

export const createNativeClientPlatform = async (data) => {
    return Fetch(
        '/native-client-platform/',
        {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
            }
        },
    )
}

export const getPlatformAssistants = async (id) => {
    return Fetch(`/native-client-platform/${id}/assistant`)
}

export const getPlatformAgents = async (id) => {
    return Fetch(`/native-client-platform/${id}/agent`)
}

export const getAvailableAgents = async (id) => {
    return Fetch(`/native-client-platform/${id}/agent/available`)
}

export const addAgentToPlatform = async (id, agentID) => {
    return Fetch(
        `/native-client-platform/${id}/agent`,
        {
            method: 'POST',
            body: JSON.stringify({ agentID }),
            headers: {
                "Content-Type": "application/json",
            }
        },
    )
}

export const removeAgentFromPlatform = async (id, agentID) => {
    return Fetch(
        `/native-client-platform/${id}/agent/${agentID}`,
        {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json",
            }
        },
    )
}

export const addAssistantToPlatform = async (id, assistantID) => {
    return Fetch(
        `/native-client-platform/${id}/assistant`,
        {
            method: 'POST',
            body: JSON.stringify({ assistantID }),
            headers: {
                "Content-Type": "application/json",
            }
        },
    )
}

export const removeAssistantFromPlatform = async (id, assistantID) => {
    return Fetch(
        `/native-client-platform/${id}/assistant/${assistantID}`,
        {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json",
            }
        },
    )
}

export const getPlatformUsers = async (id, filters = {}) => {
    const filter = new URLSearchParams(filters).toString();
    const qs = filter ? `?${filter}` : '';
    return Fetch(`/native-client-platform/${id}/users${qs}`)
}

export const getPlatformUser = async (id, userId) => {
    return Fetch(`/native-client-platform/${id}/users/${userId}`)
}

export const createPlatformUser = async (id, data) => {
    return Fetch(
        `/native-client-platform/${id}/users`,
        {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
            }
        },
    )
}

export const updatePlatformUser = async (id, userId, data) => {
    return Fetch(
        `/native-client-platform/${id}/users/${userId}`,
        {
            method: 'PUT',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
            }
        },
    )
}

export const removePlatformUser = async (id, userId) => {
    return Fetch(
        `/native-client-platform/${id}/users/${userId}/native-client-platform`,
        {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json",
            }
        },
    )
}

export const getPlatformInvites = async (id, filters = {}) => {
    const filter = new URLSearchParams(filters).toString();
    const qs = filter ? `?${filter}` : '';
    return Fetch(`/native-client-platform/${id}/users/invites${qs}`)
}

export const cancelPlatformInvite = async (id, inviteId) => {
    return Fetch(
        `/native-client-platform/${id}/users/invites/${inviteId}`,
        {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json",
            }
        },
    )
}
